import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { PackageCheck, Loader2 } from 'lucide-react';

const ReceivePRDialog = ({
  open,
  onOpenChange,
  selectedPR,
  receiveForm,
  setReceiveForm,
  locations,
  onUpload,
  uploadingReceipt,
  onSubmit,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Terima Barang</DialogTitle>
      </DialogHeader>
      {selectedPR && (
        <div className="space-y-4 py-4">
          <div className="p-3 rounded-lg bg-secondary/50 border border-border">
            <p className="text-sm font-medium">{selectedPR.item_name}</p>
            <p className="text-xs text-muted-foreground">
              Jumlah: {selectedPR.quantity} {selectedPR.unit} • Vendor: {selectedPR.vendor || '-'}
            </p>
          </div>
          <div className="space-y-2">
            <Label>Terima ke Lokasi</Label>
            <Select value={receiveForm.receive_location}
              onValueChange={(v) => setReceiveForm({ ...receiveForm, receive_location: v })}>
              <SelectTrigger data-testid="receive-location-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {locations.map((loc) => (
                  <SelectItem key={loc.id} value={loc.id}>
                    {loc.name} {loc.is_warehouse ? '(Gudang)' : ''}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Jumlah Aktual Diterima *</Label>
            <Input type="number" min="1" value={receiveForm.actual_quantity}
              onChange={(e) => setReceiveForm({ ...receiveForm, actual_quantity: e.target.value })}
              data-testid="receive-actual-quantity-input" />
            <p className="text-[11px] text-muted-foreground">
              Jumlah PR: <strong>{selectedPR.quantity} {selectedPR.unit || ''}</strong>. Ubah jika vendor kirim beda dari jumlah PR.
            </p>
          </div>
          <div className="space-y-2">
            <Label>Harga Aktual (opsional, update master barang)</Label>
            <Input type="number" min="0" value={receiveForm.actual_price}
              onChange={(e) => setReceiveForm({ ...receiveForm, actual_price: e.target.value })}
              data-testid="receive-price-input" />
          </div>
          <div className="space-y-2">
            <Label>Catatan</Label>
            <Textarea placeholder="Catatan penerimaan (opsional)"
              value={receiveForm.notes}
              onChange={(e) => setReceiveForm({ ...receiveForm, notes: e.target.value })}
              rows={2} data-testid="receive-notes-input" />
          </div>
          <div className="space-y-2">
            <Label>Bukti Tanda Terima (opsional)</Label>
            <div className="flex items-center gap-2">
              <input type="file"
                accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/*"
                onChange={onUpload} disabled={uploadingReceipt}
                className="block w-full text-xs file:mr-3 file:py-2 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-primary file:text-primary-foreground hover:file:bg-primary/90 file:cursor-pointer"
                data-testid="receive-file-input" />
              {uploadingReceipt && <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" />}
            </div>
            {receiveForm.receipt_url && (
              <div className="flex items-center justify-between text-xs bg-emerald-50 border border-emerald-200 text-emerald-900 rounded px-2 py-1.5">
                <span className="truncate">✓ {receiveForm.receipt_filename || 'File terlampir'}</span>
                <button type="button"
                  onClick={() => setReceiveForm({ ...receiveForm, receipt_url: '', receipt_filename: '' })}
                  className="text-destructive hover:underline">
                  Hapus
                </button>
              </div>
            )}
            <p className="text-[11px] text-muted-foreground">File akan muncul di invoice yang terkait tiket ini. Max 8MB.</p>
          </div>
          <div className="p-3 rounded-lg bg-emerald-50 border border-emerald-200">
            <p className="text-xs text-emerald-900">
              <strong>Info:</strong> Stok <strong>{selectedPR.item_name}</strong> di {receiveForm.receive_location} akan bertambah <strong>{parseInt(receiveForm.actual_quantity) || selectedPR.quantity}</strong>.
            </p>
          </div>
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Batal</Button>
        <Button onClick={onSubmit}
          className="bg-emerald-600 hover:bg-emerald-700 text-white"
          data-testid="save-receive-button">
          <PackageCheck className="w-4 h-4 mr-2" />
          Terima & Update Stok
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default ReceivePRDialog;
